export default __webpack_public_path__ + "static/media/background.40fc3d78.jpg";